import type { TargetAndTransition } from 'motion/react';

import { INITIAL_Z_INDEX } from './constant';
import type { VDialogProps } from './type';

export const zIndexFactory = (initalValue: number = INITIAL_Z_INDEX.MODAL) => {
  let zIndex = initalValue;

  return {
    get: () => zIndex++,
  };
};

export const getContainerHiddenVariants = ({
  transition,
}: Pick<VDialogProps, 'transition'>) => {
  const variants: TargetAndTransition = {
    opacity: 0,
  };

  switch (transition) {
    case 'fade':
      break;
    case 'slide-x':
      variants['transform'] = 'translateX(-20%)';
      break;
    case 'slide-reverse-x':
      variants['transform'] = 'translateX(20%)';
      break;
    case 'slide-y':
      variants['transform'] = 'translateY(-20%)';
      break;
    case 'slide-reverse-y':
      variants['transform'] = 'translateY(20%)';
      break;
    case 'scale':
      variants['transform'] = 'scale(0)';
      break;
  }

  return variants;
};

export const getContainerVisibleVariants = ({
  transition,
}: Pick<VDialogProps, 'transition'>) => {
  const variants: TargetAndTransition = {
    opacity: 1,
  };

  switch (transition) {
    case 'fade':
      break;
    case 'slide-x':
      variants['transform'] = 'translateX(0)';
      break;
    case 'slide-reverse-x':
      variants['transform'] = 'translateX(0)';
      break;
    case 'slide-y':
      variants['transform'] = 'translateY(0)';
      break;
    case 'slide-reverse-y':
      variants['transform'] = 'translateY(0)';
      break;
    case 'scale':
      variants['transform'] = 'scale(1)';
      break;
  }

  return variants;
};
